<div class="tf-error-filter-ctnr container">
    <div class="tf-error-filter-ctnr-info">0 results for "{{keyword}}" in {{getProductTypeMessage()}}</div>
    <div class="tf-unified-card-result-data bullet-points">
        <strong>&#x2022; Modify the filters selected.</strong> No records for the current filter combination.<br>
        <strong>&#x2022; Modify the search and try again.</strong> Spelling or typing errors.<br>
        <strong>&#x2022; Try searching for synonyms.</strong> The assay is listed under an alternate
        gene/protein name.<br>
        <strong>&#x2022; Try a different application.</strong> The query matches other Predesigned TaqMan
        product types.<br>
    </div>

    <div class="tf-unified-card-support ps-5">
        <div class="tf-unified-card-search-help"  *ngIf="!isFisherSci">
            <div class="tf-unified-card-search-tittle">Need a little search help?</div>
            <div class="tf-unified-card-search-link">
                <a href="/order/taqman-search-wizard" target="_self">
                    <div class="tf-unified-card-info-icon">
                        <div class="tf-unified-card-search-link-svg">
                            <svg width="12" height="13" viewBox="0 0 12 13" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                      d="M11.6933 11.2762L8.94212 8.50885C10.4553 6.49172 10.1871 3.64634 8.32396 1.95122C6.46086 0.25609 3.61938 0.27213 1.77531 1.98818C-0.0687522 3.70423 -0.30521 6.55246 1.23036 8.55238C2.76593 10.5523 5.56541 11.0421 7.68221 9.6813L10.4849 12.4745L11.6933 11.2762ZM2.73686 7.76745C2.1245 7.15288 1.78037 6.31852 1.78037 5.44842C1.78037 4.57832 2.1245 3.74396 2.73686 3.12939C3.34673 2.51132 4.17666 2.1637 5.04241 2.1637C5.90816 2.1637 6.73808 2.51132 7.34795 3.12939C8.61855 4.41129 8.61855 6.48555 7.34795 7.76745C6.05869 9.00888 4.02613 9.00888 2.73686 7.76745Z"/>
                            </svg>
                        </div>
                        <div class="tf-unified-card-search-link-info">
                            Go to Taqman Search Wizard
                        </div>
                    </div>

                </a>
            </div>
        </div>
        <div class="tf-unified-card-tech-help">
            <div class="tf-unified-card-search-tittle">
                Need help?
            </div>
            <div class="tf-unified-card-search-link">
                <a [href]="getContactUrl()" target="_self">Please
                    contact tech support.</a>
            </div>
        </div>
    </div>

</div>
